// src/utils/formatNumber.ts

export const formatNumber = (number: number): string => {
  return number.toLocaleString('ko-KR') + '원';
};
